// src/pages/auth/EmailVerifiedPage.tsx
import React, { useState,useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import logonegro from '../../assets/images/logonegro.svg';
import fondoPantalla from '../../assets/images/fondo_pantalla.svg';
import '../../assets/styles/auth-common.css';
import Footer from '../../components/layout/footer';
import { useWindow } from '../../context/WindowContext';
const EmailVerifiedPage: React.FC = () => {
  const navigate = useNavigate();
  const { windowWidth } = useWindow();
  const [language, setLanguage] = useState<'EN' | 'ES'>('EN');
  
  const rootStyle = {
    '--bg-image': `url(${fondoPantalla})`
  } as React.CSSProperties;

  return (
    <div style={{ backgroundColor: '#003DA5', minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '60px 20px' }}>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '30px', width: '100%' }}>
        {/* Logo centrado */}
        <div style={{ textAlign: 'center', width: '400px', maxWidth: '90vw' }}>
          <img src={logonegro} alt="Kanz Bank" style={{ width: 'auto', height: '252px', maxWidth: '100%' }} />
        </div>

        {/* Contenedor centrado */}
        <div className="auth-form-container" style={{ width: '400px', maxWidth: '90vw', position: 'relative', zIndex: 10, margin: '0', gridColumn: 'unset' }}>
          <div className="success-container">
            <div className="success-icon">✓</div>
            <h2>Email Verified Successfully!</h2>
            <p>
              Your email has been verified. You can now log in to your account and complete the registration process.
            </p>
            <div className="secondary-buttons">
              <button 
                className="btn-primary"
                onClick={() => navigate('/')}
              >
                Go to Login
              </button>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default EmailVerifiedPage;